import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * FAQ section with FAQPage JSON-LD schema for Google rich snippets.
 * items: [{ q: string, a: string }, ...]
 */
export default function FAQ({ title = "Domande frequenti", items = [] }) {
  const [open, setOpen] = useState(null);
  if (!items.length) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: it.a,
      },
    })),
  };
  return (
    <section
      data-testid="faq-section"
      className="max-w-5xl mx-auto px-4 sm:px-8 py-14 border-t border-zinc-900"
    >
      <div className="text-[10px] font-mono uppercase tracking-widest text-rose-500 mb-2">
        FAQ
      </div>
      <h2 className="font-heading text-3xl sm:text-4xl font-black uppercase text-white mb-8">
        {title}
      </h2>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div
            key={i}
            data-testid={`faq-item-${i}`}
            className="border border-zinc-800 rounded-xl bg-zinc-950/40 overflow-hidden"
          >
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between text-left px-4 sm:px-5 py-4 hover:bg-zinc-900/60 transition"
              aria-expanded={open === i}
            >
              <span className="font-semibold text-sm sm:text-base text-white pr-3">
                {it.q}
              </span>
              <ChevronDown
                size={18}
                className={`shrink-0 text-zinc-500 transition-transform ${
                  open === i ? "rotate-180 text-rose-400" : ""
                }`}
              />
            </button>
            {open === i && (
              <div className="px-4 sm:px-5 pb-5 text-sm text-zinc-300 leading-relaxed">
                {it.a}
              </div>
            )}
          </div>
        ))}
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </section>
  );
}
